export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';

export const APPROVAL_STAGES = {
  ADOPT: 'Adopt',
  TRIAL: 'Trial',
  ASSESS: 'Assess',
  HOLD: 'Hold'
};

export const APPROVAL_STAGE_COLORS = {
  'ADOPT': '#28A745',
  'TRIAL': '#2B4B81',
  'ASSESS': '#FFA500',
  'HOLD': '#DC3545'
};

export const APPROVAL_STAGE_RADII = {
  'ADOPT': 3,
  'TRIAL': 4.5,
  'ASSESS': 6,
  'HOLD': 7.5
};

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const MONTHS_WITH_NUMBERS = [
  { number: 1, name: 'January' },
  { number: 2, name: 'February' },
  { number: 3, name: 'March' },
  { number: 4, name: 'April' },
  { number: 5, name: 'May' },
  { number: 6, name: 'June' },
  { number: 7, name: 'July' },
  { number: 8, name: 'August' },
  { number: 9, name: 'September' },
  { number: 10, name: 'October' },
  { number: 11, name: 'November' },
  { number: 12, name: 'December' }
];

export const COLORS = {
  PRIMARY: '#2B4B81',
  SECONDARY: '#6B89B7',
  BACKGROUND: '#E0E6EB',
  BACKGROUND_DARK: '#E8E9EC',
  BACKGROUND_PRIMARY: '#F5F8FF',
  BACKGROUND_LIGHT: '#fbfbfb',
  TEXT: '#2B4B81',
  TEXT_LIGHT: '#6B89B7',
  EXPANDED: '#6A8DBF',
  DESTRUCTIVE: '#991b1b',
  BREADCRUMB: {
    TEXT: '#666666',
    ACTIVE: '#2B4B81',
  },
  GRAY: '#64748B',
  WHITE: '#FFFFFF',
  SUCCESS: '#16a34a',
  WARNING: '#f59e0b',
};

export const SPINNER = {
  BORDER: '#E8EDF5',
  ACTIVE: '#2B4B81',
  TEXT: '#2B4B81',
  SHADOW: 'rgba(0,0,0,0.1)'
};

export const CHART_DIMENSIONS = {
  WIDTH: 1000,
  HEIGHT: 1000,
};

export const SEGMENT_TYPE = {
    'INTERNAL': 'Internal',
    'LEAF': 'Leaf',
}

export const TREE_CHART_MODES = {
  RADAR: 'radar',    // Default view mode for radar navigation
  PROJECT: 'project', // Mode for project leaf selection
  DASHBOARD: 'dashboard', // Mode for dashboard configuration
  TREE: 'tree', // Mode for tree view
  EMPLOYEE: 'employee', // Mode for employee skill level selection
  EMPLOYEE_READ_ONLY: 'employee-read-only', // Mode for employee skill level read only
  PROJECT_READ_ONLY: 'project-read-only', // Mode for project read only
  SKILL_ASSOCIATION: 'skill-association', // Mode for skill association with leaf selection
};

export const ORG_UNIT_TYPES = {
  DELIVERY: 'delivery',
};

export const ORGANIZATION_NAME = 'Software Mind';

